<div class="login-signup-box popout" id="change-password-container">
    <button type="button" class="close circle-css" (click)="closeDialog()" aria-label="Close dialog">
        <span aria-hidden="true">&times;</span>
    </button>

    <div class="modal-header">
        <h2 [ngStyle]="clientConfig.style.color" id="change-password-modal-title" class="modal-title">Change Password</h2>
    </div>

    <div class="modal-body">
        <form [formGroup]="changePasswordForm">

            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="changeOldPassword" class="sr-only">Old Password</label>
                    <input type="password" id="changeOldPassword" formControlName="oldPassword" class="form-control"
                        placeholder="Old Password" maxlength="50" autocomplete="current-password" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.oldPassword}"
                        [attr.aria-invalid]="fc.oldPassword.invalid && fc.oldPassword.touched"
                        [attr.aria-describedby]="fc.oldPassword.errors ? 'changeOldPasswordError' : null">
                    <div *ngIf="fc.oldPassword.errors" id="changeOldPasswordError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.oldPassword.errors.required">
                            Please enter your old password
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="changeNewPassword" class="sr-only">New Password</label>
                    <input type="password" id="changeNewPassword" formControlName="password" class="form-control"
                        placeholder="New Password" maxlength="50" autocomplete="new-password" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.password}"
                        [attr.aria-invalid]="fc.password.invalid && fc.password.touched"
                        [attr.aria-describedby]="fc.password.errors ? 'changeNewPasswordError' : null">
                    <div *ngIf="fc.password.errors" id="changeNewPasswordError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.password.errors.required">
                            Please enter your new password
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label for="changeConfirmPassword" class="sr-only">Confirm Password</label>
                    <input type="password" id="changeConfirmPassword" formControlName="confirmPassword" class="form-control"
                        placeholder="Confirm Password" maxlength="50" autocomplete="new-password" aria-required="true"
                        [ngClass]="{'is-invalid': formErrors.confirmPassword}"
                        [attr.aria-invalid]="fc.confirmPassword.invalid && fc.confirmPassword.touched"
                        [attr.aria-describedby]="fc.confirmPassword.errors ? 'changeConfirmPasswordError' : null">
                    <div *ngIf="fc.confirmPassword.errors" id="changeConfirmPasswordError" class="invalid-feedback" role="alert">
                        <div *ngIf="fc.confirmPassword.errors.required">
                            Please enter confirm password
                        </div>
                        <div *ngIf="fc.confirmPassword.errors.mustMatch">
                            Password & Confirm Password are different
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <button type="button" (click)="changePassword()" [disabled]="!changePasswordForm.valid"
                    [ngStyle]="clientConfig.style.bg" class="app-btn btn btn-danger btn-block">Change Password</button>
            </div>
        </form>
    </div>

</div>